import { brightcoveConfig } from '../../../config'

const isOnDemand = (livestream) => livestream?.livestreamId === 'onDemand'

export function getBrightcoveIds(videoProvider, isLive) {
  if (videoProvider?.providerType !== 'brightcove') return {}
  const { videoId, accountId, liveStream } = videoProvider
  if (liveStream && isLive && !isOnDemand(liveStream)) {
    return {
      videoId: liveStream.livestreamId,
      accountId: liveStream.accountId,
    }
  }

  if (!videoId) return {}
  return { videoId, accountId: accountId ?? brightcoveConfig.master.accountId }
}

const isNumber = (value) => {
  return !Number.isNaN(parseFloat(value)) && Number.isFinite(value)
}

export function getVideoProvider(videoProvider, isLive) {
  if (!videoProvider) return 'none'
  const { videoId, providerType } = videoProvider

  switch (providerType) {
    case 'brightcove':
      if (!isLive && !isNumber(videoId)) {
        return 'processing'
      }
      return 'brightcove'
    case 'youtube':
      return 'youtube'
    case 'WEBINAR':
      return 'webinar'
    case 'countdown':
      return 'countdown'
    default:
      return undefined
  }
}
